import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Tip = Loadable({
    loader: () => import(/* webpackChunkName: "Tip" */ './tip'),
    loading: () => <div />,
});
